module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.selection), function(item) {
    return _c('div', {
      staticClass: "checkbox"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.IsSelected),
        expression: "item.IsSelected"
      }],
      attrs: {
        "type": "checkbox",
        "true-value": true,
        "false-value": false
      },
      domProps: {
        "checked": Array.isArray(item.IsSelected) ? _vm._i(item.IsSelected, null) > -1 : (item.IsSelected)
      },
      on: {
        "change": [function($event) {
          var $$a = item.IsSelected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (item.IsSelected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (item.IsSelected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(item, "IsSelected", $$c)
          }
        }, _vm.UpdateSelection]
      }
    }), _vm._v(" " + _vm._s(item.Object) + "\n        ")])])
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4eed95cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4eed95cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/ChartSelector/ChartSelector.scp.html
// module id = 543
// module chunks = 0